import { render, staticRenderFns } from "./WidgetDrivingSummary.vue?vue&type=template&id=32ac2cc3&scoped=true&"
import script from "./WidgetDrivingSummary.vue?vue&type=script&lang=js&"
export * from "./WidgetDrivingSummary.vue?vue&type=script&lang=js&"
import style0 from "./WidgetDrivingSummary.vue?vue&type=style&index=0&id=32ac2cc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ac2cc3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32ac2cc3')) {
      api.createRecord('32ac2cc3', component.options)
    } else {
      api.reload('32ac2cc3', component.options)
    }
    module.hot.accept("./WidgetDrivingSummary.vue?vue&type=template&id=32ac2cc3&scoped=true&", function () {
      api.rerender('32ac2cc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/widgets/WidgetDrivingSummary.vue"
export default component.exports